export type PortalLocale = "es" | "en" | "pt";

const localeMap: Record<PortalLocale, string> = {
  es: "es-ES",
  en: "en-US",
  pt: "pt-BR"
};

export function normalizePortalLocale(value: string | null | undefined): PortalLocale {
  const language = String(value ?? "es").trim().toLowerCase().split(/[-_]/u)[0];
  return language === "en" || language === "pt" ? language : "es";
}

export function intlLocale(value: string | null | undefined): string {
  return localeMap[normalizePortalLocale(value)];
}

export function formatPortalDate(
  value: string,
  timezone = "UTC",
  locale: string | null | undefined = "es",
  options: Intl.DateTimeFormatOptions = { dateStyle: "medium", timeStyle: "short" }
): string {
  try {
    return new Intl.DateTimeFormat(intlLocale(locale), { ...options, timeZone: timezone }).format(new Date(value));
  } catch {
    return new Date(value).toLocaleString(intlLocale(locale));
  }
}

export function formatPortalMoney(cents: number, currency = "EUR", locale: string | null | undefined = "es"): string {
  try {
    return new Intl.NumberFormat(intlLocale(locale), { style: "currency", currency }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

export function portalWeekdayNames(locale: string | null | undefined = "es"): string[] {
  const formatter = new Intl.DateTimeFormat(intlLocale(locale), { weekday: "long", timeZone: "UTC" });
  return Array.from({ length: 7 }, (_, index) => formatter.format(new Date(Date.UTC(2024, 0, 7 + index))));
}
